import { Employee } from 'generated/schema-types';
import { createContext } from 'react';

const UserContext = createContext<Employee | null>(null);
export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;
export default UserContext;
